module.exports = __webpack_public_path__ + "img/desk1.3706021b.png";